<template>
  <div class="home-page">
    <div
      :class="{
        'home-page-block-1': true,
        '--started-1': startAnim,
        '--started-2': startAnim2,
      }"
    >
      <img class="_light" src="../assets/img/404-light.png" />
      <img
        class="_light _light--mob"
        src="../assets/img/home/mobile-first-block-light.png"
      />
      <div class="home-page-block-1__content">
        <span class="_kr-left-wrap">
          <img class="_kr-left" src="../assets/img/kr-left.png" />
        </span>
        <span class="_kr-right-wrap">
          <img class="_kr-right" src="../assets/img/kr-right.png" />
        </span>
        <img class="_logo" src="../assets/img/logo.svg" alt="" />
        <div class="_text">
          <div class="_row-1">ТВОЙ,</div>
          <div class="_row-2">хрустающий!</div>
        </div>
      </div>
      <span class="home-page-block-1__arrow-wrap">
        <ArrowDown />
      </span>
    </div>
    <div class="mini-format">
      <img
        class="mini-format__words --desc"
        src="../assets/img/mini-format/words.svg"
      />
      <img
        class="mini-format__words --mob"
        src="../assets/img/home/mobile-mini-format-title.svg"
      />
    </div>
    <ProductSlider />
    <NumberOne />
    <BrightBlock />

    <!-- <div class="mood-video">
      <video muted playsinline="" loop autoplay>
        <source src="../assets/video.mp4" type="video/mp4" />
      </video>
    </div> -->
    <Reviews />
    <WhereBuy :fullVersion="true" />
  </div>
</template>

<script>
import Reviews from "@/components/Reviews.vue"
import ProductSlider from "@/components/ProductSlider.vue"
import NumberOne from "@/components/NumberOne.vue"
import BrightBlock from "@/components/BrightBlock.vue"
import WhereBuy from "@/components/WhereBuy.vue"
import ArrowDown from "@/components/ArrowDown.vue"

export default {
  name: "HomeView",
  components: {
    ProductSlider,
    NumberOne,
    BrightBlock,
    Reviews,
    WhereBuy,
    ArrowDown,
  },
  data() {
    return {
      startAnim: false,
      startAnim2: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.startAnim = true
    }, 200)
    setTimeout(() => {
      this.startAnim2 = true
    }, 500)
  },
}
</script>

<style lang="scss">
.home-page-block-1 {
  min-height: 100vh;
  @include respond-to("smartphone-plus") {
    height: var(--app-height);
  }
  background-color: $color-yellow;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  &__arrow-wrap {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10%;
    z-index: 10;
  }
  ._light {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100%;
    z-index: 0;
    transform: translate(-40%, -40%);
    opacity: 0;
    // transform: translateY(100px);
    transition: all 0.3s ease-in;
    // transition-delay: 0.8s;
  }
  ._light--mob {
    display: none;
  }
  &__content {
    height: 275px;
    position: relative;
    ._kr-left,
    ._kr-right {
      height: 275px;
      position: relative;
      transition: all 0.5s ease-out;
      transition-delay: 0.3s;
    }
    ._kr-left {
      z-index: 10;
      transform: translate(80px, 7px);
      top: 0px;
      left: 0px;
    }
    ._kr-right {
      z-index: 9;
      transform: translateX(-10px);
    }
    ._kr-left-wrap {
      position: relative;
      z-index: 10;
    }
    ._kr-right-wrap {
      position: relative;
      z-index: 9;
    }
    ._logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 164px;
      transform: translate(-50%, -120%);
      opacity: 0;
      transition: all 0.2s ease-in;
      transition-delay: 1s;
    }
    ._text {
      top: -175px;
      position: relative;
      font-family: $font-peach;
      font-size: 10.5rem;
      color: $color-blue;
      text-align: center;
      line-height: 0.7;
      opacity: 0;
      transition: all 0.2s ease-in;
      transition-delay: 1s;
      > div + div {
        margin-top: 32px;
      }
      ._row-1 {
        transform: rotate(-4.7deg);
      }
      ._row-2 {
        transform: rotate(1.7deg);
      }
    }
  }
  &.--started-1 {
    ._light {
      opacity: 1;
      transform: translate(-40%, -50%);
    }
  }
  &.--started-2 {
    ._kr-left-wrap {
      animation: vibrate-1 0.3s;
    }
    ._kr-right-wrap {
      animation: vibrate-2 0.3s;
    }
    ._kr-left {
      top: 0px;
      left: 0px;
      transform: translate(-280px, 61px) rotate(-20deg);
    }
    ._kr-right {
      transform: translate(280px, 56px) rotate(20deg);
    }
    ._logo {
      width: 224px;
      opacity: 1;
    }
    ._text {
      opacity: 1;
    }
  }
  @include respond-to("small") {
    .home-page-block-1__content {
      ._text {
        font-size: 9.2rem;
      }
    }
    &.--started-2 ._logo {
      width: 180px;
      transform: translate(-50%, -280px);
    }
    &__content ._kr-left,
    &__content ._kr-right {
      height: 225px;
    }
  }
  @include respond-to("smartphone-plus") {
    overflow: hidden;
    ._light {
      display: none;
    }
    ._light--mob {
      display: block;
    }
    .home-page-block-1__content {
      height: auto;
      ._kr-left,
      ._kr-right {
        height: 155px;
        // display: none;
      }
      ._kr-left {
        // transform: translate(-280px, 61px) rotate(-45deg);
      }
      ._kr-right {
        // transform: translate(280px, 56px) rotate(45deg);
      }
      ._text {
        font-size: 5.3rem;
        top: -40px;
        div + div {
          margin-top: 18px;
        }
      }
      ._logo {
        width: 112px;
        transform: translate(-50%, -120%);
      }
    }
    &.--started-2 {
      ._kr-left {
        transform: translate(-30px, -161px) rotate(45deg) !important;
      }
      ._kr-right {
        transform: translate(50px, 246px) rotate(45deg) !important;
      }
    }
  }
}
.mini-format {
  background: url(../assets/img/mini-format/bg.jpg) no-repeat center;
  background-size: cover;
  min-height: 100vh;
  position: relative;
  &__words {
    position: absolute;
    left: 52%;
    top: 17%;
    &.--mob {
      display: none;
    }
  }
  @include respond-to("small") {
    .mini-format__words {
      width: 40%;
    }
  }
  @include respond-to("smartphone-plus") {
    background: url(../assets/img/home/mobile-mini-format.png) no-repeat center;
    background-size: cover;
    margin-top: -40px;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;

    .mini-format__words {
      display: none;
    }
    .mini-format__words.--mob {
      display: block;
      left: 50%;
      top: 50px;
      transform: translate(-50%, 0);
    }
  }
}
.mood-video {
  background-color: #efefef;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  video {
    width: 100%;
  }
}
</style>
